import { render, staticRenderFns } from "./VSelect.vue?vue&type=template&id=7a2a2742&scoped=true&lang=pug&"
import script from "./VSelect.vue?vue&type=script&lang=js&"
export * from "./VSelect.vue?vue&type=script&lang=js&"
import style0 from "./VSelect.vue?vue&type=style&index=0&id=7a2a2742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2a2742",
  null
  
)

export default component.exports